import { createSlice } from "@reduxjs/toolkit";

import {
  getDirectorateThunk,
  createDirectorateThunk,
  updateDirectorateThunk,
  deleteDirectorateThunk,
} from "state/action/directorate";

// Initial state
const initialState = {
  // Get Directorate inisial state
  getDirectorate: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Create Directorate inisial state
  createDirectorate: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Update Directorate inisial state
  updateDirectorate: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Delete Directorate inisial state
  deleteDirectorate: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },

  createDirectorateInputBody: {
    name: "",
    email: "",
    description: "",
    division: [""],
    represented_by: [
      {
        name: "",
        title: "",
      },
    ],
    code: "",
  },
  selectedDirectorate: {
    name: "",
    email: "",
    description: "",
    department: [""],
    represented_by: [
      {
        name: "",
        title: "",
      },
    ],
    code: "",
  },
  // Directorate object value
  directorate_object_value: "",
};

export const directorateSlice = createSlice({
  name: "directorate",
  initialState,
  reducers: {
    setDirectorateField: (state, action) => {
      const { field, value } = action.payload;
      state.createDirectorateInputBody[field] = value;
    },
    // --- Handle Represented By (Leaders) ---
    addRepresentative: (state) => {
      state.createDirectorateInputBody.represented_by.push({
        name: "",
        title: "",
      });
    },
    removeRepresentative: (state, action) => {
      state.createDirectorateInputBody.represented_by.splice(action.payload, 1);
    },
    updateRepresentative: (state, action) => {
      const { index, field, value } = action.payload;
      state.createDirectorateInputBody.represented_by[index][field] = value;
    },

    removeDivision: (state, action) => {
      state.createDirectorateInputBody.division.splice(action.payload, 1);
    },
    updateDivision: (state, action) => {
      const { index, value } = action.payload;
      state.createDirectorateInputBody.division[index] = value;
    },
    resetDirectorateForm: (state) => {
      state.createDirectorateInputBody =
        initialState.createDirectorateInputBody;
    },

    // --- Reducers untuk array 'division' ---
    addDivision: (state) => {
      state.createDirectorateInputBody.division.push("");
    },

    setGetDirectorateObjectValue: (state, action) => {
      return {
        ...state,
        directorate_object_value: action.payload,
      };
    },
    // note: clear state
    setClearGetDirectorateObjectValue: (state, _) => {
      return {
        ...state,
        directorate_object_value: "",
      };
    },
    setCreateDirectorateInputBody: (state, action) => {
      return {
        ...state,
        createDirectorateInputBody: action.payload,
      };
    },
    setSelectedDirectorate: (state, action) => {
      return {
        ...state,
        selectedDirectorate: action.payload,
      };
    },

    setClearCreateDirectorateInputBody: (state, _) => {
      return {
        ...state,
        createDirectorateInputBody: {
          name: "",
          email: "",
          description: "",
          division: [""],
          represented_by: [
            {
              name: "",
              title: "",
            },
          ],
          code: "",
        },
      };
    },
    setClearCreateDirectorate: (state, _) => {
      return {
        ...state,
        createDirectorate: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearGetDirectorate: (state, _) => {
      return {
        ...state,
        getDirectorate: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearUpdateDirectorate: (state, _) => {
      return {
        ...state,
        updateDirectorate: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearDeleteDirectorate: (state, _) => {
      return {
        ...state,
        deleteDirectorate: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearAllDirectorateState: (state, _) => {
      return {
        ...state,
        // Get Directorate inisial state
        getDirectorate: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Create Directorate inisial state
        createDirectorate: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Update Directorate inisial state
        updateDirectorate: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Delete Directorate inisial state
        deleteDirectorate: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Directorate object value
        directorate_object_value: "",
      };
    },
  },
  extraReducers(builder) {
    builder
      // Get Directorate reducer
      .addCase(getDirectorateThunk.pending, (state, _) => {
        return {
          ...state,
          getDirectorate: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getDirectorateThunk.fulfilled, (state, action) => {
        return {
          ...state,
          getDirectorate: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getDirectorateThunk.rejected, (state, action) => {
        return {
          ...state,
          getDirectorate: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // Create Directorate reducer
      .addCase(createDirectorateThunk.pending, (state, _) => {
        return {
          ...state,
          register: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createDirectorateThunk.fulfilled, (state, action) => {
        return {
          ...state,
          register: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createDirectorateThunk.rejected, (state, action) => {
        return {
          ...state,
          register: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // update Directorate reducer
      .addCase(updateDirectorateThunk.pending, (state, _) => {
        return {
          ...state,
          updateDirectorate: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateDirectorateThunk.fulfilled, (state, action) => {
        return {
          ...state,
          updateDirectorate: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateDirectorateThunk.rejected, (state, action) => {
        return {
          ...state,
          updateDirectorate: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      });
  },
});

export const directorateAction = {
  ...directorateSlice.actions,
  getDirectorateThunk,
  createDirectorateThunk,
  updateDirectorateThunk,
  deleteDirectorateThunk,
};

export function selectDirectorateObjectValue(state) {
  return state?.directorate?.directorate_object_value;
}

export function selectDirectorate(state) {
  return state?.directorate;
}

export default directorateSlice.reducer;
